import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType } from "DataTypes/Form";
import { AddEditForm } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { DataActionType } from ".";

interface AddEditViewModalProps {
  onClose: () => void;
  refreshList: () => void;
  dataAction: DataActionType
}

const UpdateProblems: FC<AddEditViewModalProps> = (props) => {
  const { dataAction, onClose, refreshList } = props;
  const isEdit = dataAction.action == "EDIT";
  const isView = dataAction.action == "VIEW";
  const [formData, setFormData] =
    useState<FormObjType[]>(JSON.parse(JSON.stringify(AddEditForm)));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleLoadData();
  }, [dataAction.data?.id, dataAction.action]);

  const handleLoadData: () => void = () => {
    let newFormData: FormObjType[] = JSON.parse(JSON.stringify(AddEditForm));
    if (isEdit || isView) {
      newFormData[0].boxType == "single-select" &&
        (newFormData[0].dropVal = dataAction?.data?.problemId);
      newFormData[1].boxType == "single-select" &&
        (newFormData[1].dropVal = dataAction?.data?.altCodeId);
      newFormData[2].inputVal = "";
      newFormData[3].inputVal = "";
      newFormData[4].inputVal = "";
    }
    if (isView) {
      newFormData = newFormData.map(el => ({ ...el, readOnly: true }));
    }
    setFormData(newFormData);
  }

  const handleSave: () => void = () => {
    setLoading(true);
    !isEdit && setFormData([...AddEditForm]);
    refreshList();
    setLoading(false);
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold">
          {isEdit ? (isView ? "View" : "Edit") : "Add"} Problem
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid key={el.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                {FormObjSwitch({
                  formObj: el,
                  inputChange: async (props) => {
                    setFormData(
                      CommonFormatter.HandleInputChange(props, formData)
                    );
                  },
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  }

                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent={"flex-end"}
          sx={{ "&>button": { ml: 1 } }}
        >
          {!isView && (
            <CstmBtn
              label={loading ? "Loading..." : "Save"}
              onClick={handleSave}
              disable={loading}
            />
          )}
          <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
        </Box>
      </Box>
    </Fragment>
  );
};

export default UpdateProblems;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};
